import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ResourceData } from '@app/shared/abstract/resource.data';
import { EventAdjustmentModel } from '@app/events/shared/event-adjustment.model';

export interface EventAdjustmentPayload {
  description: string;
  amount: number;
  category: string;
}

/**
 * TVG-156: admin-only discount / adjustment lines on an event finance.
 * Reads are available to staff who can view the event; writes are admin only
 * (enforced server-side by the role:admin middleware).
 */
@Injectable({
  providedIn: 'root',
})
export class EventAdjustmentService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  list(eventId: number): Observable<{ data: EventAdjustmentModel[] }> {
    return this.http.get<{ data: EventAdjustmentModel[] }>(
      `${this.apiUrl}/api/events/${eventId}/adjustments`
    );
  }

  create(eventId: number, payload: EventAdjustmentPayload): Observable<ResourceData<EventAdjustmentModel>> {
    return this.http.post<ResourceData<EventAdjustmentModel>>(
      `${this.apiUrl}/api/events/${eventId}/adjustments`,
      payload
    );
  }

  update(adjustmentId: number, payload: EventAdjustmentPayload): Observable<ResourceData<EventAdjustmentModel>> {
    return this.http.put<ResourceData<EventAdjustmentModel>>(
      `${this.apiUrl}/api/event-adjustments/${adjustmentId}`,
      payload
    );
  }

  delete(adjustmentId: number): Observable<unknown> {
    return this.http.delete(`${this.apiUrl}/api/event-adjustments/${adjustmentId}`);
  }
}
